<div class="max-width-p">
    <div class="mt-2 mb-4">
        <benefit-header-summary [headerText]="shop.name" [showBudgetCard]="false"></benefit-header-summary>
    </div>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-3">
                    <img [src]="shop?.logo" class="img" *ngIf="shop" alt="" role="presentation"/>
                </div>
                <div class="col-9 text-align-left coupon-title">
                    {{ 'CASHBACK.DETAILS_PAGE.SHOP_DESCRIPTION' | translate: {name: shop.name} }}
                </div>
            </div>
        </div>
    </div>

    <div class="offers-wide">
        <div class="medical-cards">
            <div class="d-flex customOffers">
                <div class="card clickable" *ngFor="let coupon of shopCoupons" [routerLink]="coupon.slug">
                    <div class="card-header text-left">
                        <div class="card-title">
                            <span *ngIf="coupon.discountPercent === 0; else hasDiscountValue"
                                  class="display-4 text-danger darken-2">
                                {{ 'CASHBACK.DETAILS_PAGE.GENERAL_OFFER' | translate }}
                            </span>
                            <ng-template #hasDiscountValue>
                                <span class="display-3 text-danger darken-2">{{ coupon.discountPercent }}</span>&nbsp;<span
                                    class="display-5 brick-red darken-2 text-left" *ngIf="coupon.discountType === 'percent'">%</span>
                                <span
                                        class="display-5 brick-red darken-2 text-left" *ngIf="coupon.discountType === 'fixed'">RON</span>
                            </ng-template>
                        </div>
                        <hr/>
                    </div>
                    <div class="card-body mb-0 spaced-content">
                        <div>
                            <p>{{ coupon.title }}</p>
                            <p>{{ coupon.description }}</p>
                        </div>
                        <div>
                            <h6 class="card-subtitle small-text mt-1">{{ 'CASHBACK.DETAILS_PAGE.VALID_UNTIL' | translate: {'date': coupon.endDate} }}</h6>
                            <a class="card-link c-company bold" [routerLink]="coupon.slug">
                                {{ 'CASHBACK.DETAILS_PAGE.SELECT_COUPON_ACTION' | translate }}
                            </a>
                        </div>
                    </div>
                </div>

                <div class="card clickable" *ngIf="shop.cashback" (click)="loadCashback(shop)">
                    <div class="card-header text-left">
                        <div class="card-title">
                                <span class="display-3 text-danger darken-2">{{ shop.cashback.cashbackValue.replace("până la", "").replace('%', '') }}</span>&nbsp;<span
                                class="display-5 text-danger darken-2 text-left">%</span>
                            <br />
                        </div>
                        <hr/>
                    </div>
                    <div class="card-body mb-0 spaced-content">
                        <div>
                            <p>Cashback</p>
                            <p *ngIf="shop.cashback.averagePayoutTerm">{{ 'CASHBACK.DETAILS_PAGE.AVERAGE_PAYOUT' | translate : {payout: shop.cashback.averagePayoutTerm} }}</p>
                            <p [innerHTML]="shop.cashback.cashbackConditions" style="max-height: 350px; overflow-y: auto"></p>
                        </div>
                        <div>
                            <a class="card-link c-company bold">
                                {{ 'CASHBACK.DETAILS_PAGE.SELECT_CASHBACK_ACTION' | translate }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
